export const COOKIEPRO_SCRIPT_SRC = 'https://cookie-cdn.cookiepro.com/scripttemplates/otSDKStub.js'

export const DEFAULT_COOKIEPRO_DOMAIN_SCRIPT_ID = 'c4b48adc-e516-45dd-bf05-7e8b26cd0477'

export const COOKIEPRO_DOMAIN_SCRIPT_ENV_KEY = 'NEXT_PUBLIC_COOKIEPRO_DOMAIN_SCRIPT_ID'

export const COOKIEPRO_DISABLE_RULES_FLAG_KEY = 'cookiepro-disable-rules'

export const CONSENT_BANNER_ELEMENT_ID = 'onetrust-banner-sdk'

export const CONSENT_BANNER_CLEARANCE = 8

/**
 * Set by OneTrust once consent is given. Its presence means the banner will not be shown: the
 * banner only returns after this cookie expires or is deleted.
 */
export const CONSENT_ALERT_BOX_CLOSED_COOKIE = 'OptanonAlertBoxClosed'

export type CookieProDisableRulesPayload = {
  disabledPaths?: string[]
  disabledPathPrefixes?: string[]
}

const isStringArray = (value: unknown): value is string[] => {
  return Array.isArray(value) && value.every((item) => typeof item === 'string')
}

const stripLocalePrefix = (pathname: string): string => {
  const pathWithoutLocale = pathname.replace(/^\/[a-z]{2}-[A-Z]{2}(?=\/|$)/, '')
  return pathWithoutLocale || '/'
}

const getCookieProRulePathCandidates = (pathname: string): string[] => {
  const pathWithoutLocale = stripLocalePrefix(pathname)
  return pathname === pathWithoutLocale ? [pathname] : [pathname, pathWithoutLocale]
}

const matchesCookieProDisableRules = (
  pathCandidates: string[],
  rules: CookieProDisableRulesPayload,
): boolean => {
  const disabledPaths = rules.disabledPaths ?? []
  if (disabledPaths.some((disabledPath) => pathCandidates.includes(disabledPath))) return true

  const disabledPathPrefixes = rules.disabledPathPrefixes ?? []
  return disabledPathPrefixes.some(
    (prefix) => prefix !== '' && pathCandidates.some((path) => path.startsWith(prefix)),
  )
}

export const isCookieProDisableRulesPayload = (
  value: unknown,
): value is CookieProDisableRulesPayload => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false

  const payload = value as Record<string, unknown>
  const { disabledPaths, disabledPathPrefixes } = payload

  return (
    (disabledPaths === undefined || isStringArray(disabledPaths)) &&
    (disabledPathPrefixes === undefined || isStringArray(disabledPathPrefixes))
  )
}

export const shouldDisableCookieProForPath = (pathname: string, payload: unknown): boolean => {
  if (!isCookieProDisableRulesPayload(payload)) return false

  return matchesCookieProDisableRules(getCookieProRulePathCandidates(pathname), payload)
}
